import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { setVehicleConfiguration } from '../actions/setVehicleConfiguration';
import { formSubmitNRTracking } from '../helpers/logging-client';
import stepController from '../controllers/StepController';

const Form = ({ setCurrentStep }) => {
	const formRef = useRef(null);
	setCurrentStep('form');
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { vehicleConfiguration, rootDir } = useSelector((state) => state);
	const {
		year,
		make,
		model,
		trimName,
		price,
		options: {
			drivetrain,
			cabType,
			paint,
			packages: { selections }
		}
	} = vehicleConfiguration;

	useEffect(() => {
		if (!drivetrain.value) {
			const lsVehicleConfig = stepController.getLsVehicleConfig();
			if (
				!lsVehicleConfig ||
				!lsVehicleConfig.make ||
				!lsVehicleConfig.model
			) {
				navigate(stepController.getRootPath());
			} else {
				dispatch(setVehicleConfiguration(lsVehicleConfig));
				const trimScreenPath = `/${rootDir}/${lsVehicleConfig.make}/${lsVehicleConfig.model}.htm`;
				navigate(trimScreenPath);
			}
			return null;
		}

		const formContainer = document.getElementById(
			'car-customizer-form-container'
		);
		const form = document.querySelector(
			'form[data-form-tracking-name="car-customizer-form"]'
		);
		const formElements = form.elements;
		const formGuid = document
			.getElementById('car-customizer-form-guid')
			.getAttribute('data-id');

		form.querySelector('.form-group.clearfix.clear')?.classList?.remove(
			'form-group'
		);

		formElements[`${formGuid}-year`].setAttribute('value', year);
		formElements[`${formGuid}-make`].setAttribute('value', make);
		formElements[`${formGuid}-model`].setAttribute('value', model);
		formElements[`${formGuid}-trim`].setAttribute('value', trimName);
		formElements[`${formGuid}-price`].setAttribute('value', price);
		formElements[`${formGuid}-drivetrain`].setAttribute(
			'value',
			drivetrain.value
		);
		if (cabType) {
			formElements[`${formGuid}-cabType`].setAttribute(
				'value',
				cabType.value
			);
		}
		formElements[`${formGuid}-paintColor`].setAttribute(
			'value',
			paint.value
		);
		formElements[`${formGuid}-packages`].setAttribute(
			'value',
			selections.map((selection) => selection.description)
		);
		formRef.current.appendChild(form);
		return () => {
			formContainer.appendChild(form);
		};
	}, []);

	// subscribe to form complete topic
	useEffect(() => {
		window.DDC.pubsub.subscribe('car-customizer:form-complete', () => {
			formSubmitNRTracking(year, make, model, trimName);
			const confirmationPath = `/${rootDir}/${make}/${model}/confirm.htm`;
			navigate(confirmationPath);
		});
	}, [navigate]);

	return (
		<React.Fragment>
			<div
				className="text-left"
				ref={formRef}
				data-testid="form-container"
			/>
		</React.Fragment>
	);
};

Form.propTypes = {
	setCurrentStep: PropTypes.func
};

export default Form;
